<form [formGroup]="form" (ngSubmit)="submit()">
  <title mat-dialog-title>{{ 'communication.chat.export.selectTimeFrame' | t }}</title>
  <mat-dialog-content>
    <sn-form [form]="form" [fields]="formFields" [(model)]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="danger" mat-dialog-close="close">{{ 'common.cancel' | t }}</button>
    <button mat-button color="success" type="submit" [disabled]="form.invalid">{{ 'common.submit' | t }}</button>
  </mat-dialog-actions>
</form>
